import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

const fmtMonto = (v) =>
  Math.abs(Number(v || 0)).toLocaleString('es-AR', { maximumFractionDigits: 0 });

export const ComisionesWarnings = ({ warnings }) => {
  const [open, setOpen] = useState(false);
  const ncSolas = warnings?.nc_sin_pareja || [];
  if (ncSolas.length === 0) return null;

  return (
    <div className="flex justify-end mb-1" data-testid="comisiones-warnings-banner">
      <div className="relative inline-block">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          title={`${ncSolas.length} NC sin factura vinculada`}
          className="flex items-center gap-1 px-2 py-1 rounded text-yellow-600/50 hover:text-yellow-500/80 transition-colors"
          data-testid="comisiones-warnings-toggle"
        >
          <AlertTriangle size={13} className="shrink-0" />
          <span className="text-[11px] text-yellow-600/50">
            {ncSolas.length} NC sin vincular
          </span>
        </button>

        {open && (
          <div
            className="absolute right-0 top-full mt-1 z-50 w-max max-w-[92vw] rounded-lg border border-neutral-700 bg-neutral-900 shadow-xl"
            data-testid="comisiones-warnings-table"
          >
            <div className="flex items-center justify-between px-3 py-2 border-b border-neutral-800">
              <span className="text-[11px] text-yellow-500/70 font-medium">
                {ncSolas.length} NC sin factura vinculada
              </span>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-gray-600 hover:text-gray-400 text-xs ml-4"
              >✕</button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead>
                  <tr className="text-[10px] uppercase tracking-wider text-gray-500 border-b border-neutral-800">
                    <th className="px-3 py-2 text-left">Nº</th>
                    <th className="px-3 py-2 text-left">Influencer</th>
                    <th className="px-3 py-2 text-left">Marca</th>
                    <th className="px-3 py-2 text-left">KAM</th>
                    <th className="px-3 py-2 text-right">Monto</th>
                    <th className="px-3 py-2 text-left">Mes pedido</th>
                  </tr>
                </thead>
                <tbody>
                  {ncSolas.map((r, i) => (
                    <tr key={i} className="border-b border-neutral-800/60">
                      <td className="px-3 py-2 font-mono text-yellow-600/70">{r.nro_factura || '—'}</td>
                      <td className="px-3 py-2 text-gray-300">{r.influencer || '—'}</td>
                      <td className="px-3 py-2 text-gray-400">{r.agencia || '—'}</td>
                      <td className="px-3 py-2 text-gray-400">{r.kam || '—'}</td>
                      <td className="px-3 py-2 text-right font-mono text-red-400/80">
                        -{fmtMonto(r.valor)}
                      </td>
                      <td className="px-3 py-2 text-gray-500">{r.mes_pedido || r.month || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
